import { Flex, Typography } from "antd"
import cls from "classnames"

import Icon from "../../../../../Icon"
import { faqIcons } from "../../../../../Utils/utils"

import "./FaqCard.less"

const { Title, Text } = Typography

const FaqCard = ({ title, text, className, styles = {} }) => (
  <Flex className={cls("referral-faq-card", className)} style={styles} vertical>
    <Icon style={{ color: "#225AEA" }} type={faqIcons[title]} />
    <Title level={4} className="faq-tile">
      {title}
    </Title>
    <div className="faq-text">{text}</div>
  </Flex>
)

export default FaqCard
